export default {
    college: { collegeName: '全部', collegeId: 0, subspecialties: [] }, //学科id
    subMajor: { subspecialtyName: '全部', subspecialtyId: 0, subspecialties: [] } // 亚专业id
}